<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $tc('kiosk.title', 2) }}</h1>
        <router-link :to="{ name: 'add-kiosk' }" class="link">
          {{ $t('kiosk.add_kiosk') }}
          <i class="icon icon--plus"></i>
        </router-link>
    </div>
    <div class="details-component__content content" v-if="kiosks">
      <v-client-table :data="kiosks" :columns="columns" :options="options"></v-client-table>
    </div>
     <ConfirmationModal v-if="showConfirmationModal" @cancel="cancel" @confirmed="remove">
      <h1 slot="header">{{ $t('common.removing') }}: {{ removeKiosk.description }} </h1>
      <p slot="body">{{ $t('kiosk.confirm_remove') }}</p>
    </ConfirmationModal>
    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ warningHeader }}</h1>
      <p slot="body">{{ warningBody }}</p>
    </WarningModal>
  </div>
</template>

<script>
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';

export default {
  props: ['kiosks', 'tenant'],
  components: {
    ConfirmationModal,
    WarningModal,
  },
  computed: mapGetters({
    user: 'user/user/user',
  }),
  methods: {
    remove() {
      this.showConfirmationModal = false;
      this.$store.dispatch('kiosks/kiosk/delete', { id: this.removeKiosk.id, user: this.user })
        .then(() => {
          if (!this.kioskError) {
            this.$store.commit(`tenants/tenant/${mTypes.REMOVE_KIOSK}`, this.removeKiosk.id);
          } else {
            this.warningHeader = this.$t('accounts.removing_error_header'); // todo
            this.warningBody = this.$t('accounts.removing_error'); // todo
            this.showWarningModal = true;
          }
          this.removeKiosk = {};
        });
    },
    closeWarningModal() {
      this.showWarningModal = false;
    },
    showConfirmation(kiosk) {
      this.removeKiosk = kiosk;
      this.showConfirmationModal = true;
    },
    cancel() {
      this.showConfirmationModal = false;
    },
    edit(kiosk) {
      this.$router.push({ name: 'edit-kiosk', params: { id: kiosk.id } });
    },
    routeToProduct(product) {
      this.$router.push({ name: 'product', params: { id: product.id } });
    },
    showHashInfo(kiosk) {
      const title = kiosk.hash_enabled ?
        this.$t('kiosk.hashIsEnabled') :
        this.$t('kiosk.hashIsDisabled');

      const content = kiosk.hash_enabled ?
        `${process.env.BASE_URL}kiosk/?hash=${kiosk.kiosk_hash}` :
        '';

      this.$alert(content, title, {
        confirmButtonText: 'OK',
      });
    },
  },
  data() {
    return {
      showConfirmationModal: false,
      showWarningModal: false,
      warningBody: null,
      warningHeader: null,
      removeKiosk: {},
      form: {},
      columns: ['product', 'description', 'pin', 'kiosk_hash', 'amount', 'created_at', 'edit_kiosk', 'remove_kiosk'],
      options: {
        rowClassCallback: () => 'VueTables__row',
        filterable: false,
        headings: {
          product: () => this.$t('common.product'),
          description: () => this.$t('kiosk.description'),
          pin: () => this.$t('kiosk.pin'),
          created_at: () => this.$t('common.created_at'),
          kiosk_hash: () => this.$t('kiosk.hash'),
          amount: () => this.$t('kiosk.amount'),
          edit_kiosk: () => (''),
          remove_kiosk: () => (''),
        },
        texts: {
          noResults: this.$t('tables.noRecords'),
          count: this.$t('tables.count'),
        },
        templates: {
          product: (h, row) => (
            <a class="link" on-click={ () => this.routeToProduct(row.product) }>
              <span>{row.product.name}</span>
            </a>
          ),
          kiosk_hash: (h, row) => (
            <div class="hash-button-wrapper">
              <a on-click={ () => this.showHashInfo(row) } id={row.id}>
                { this.$t('kiosk.link') }
              </a>
            </div>
          ),
          edit_kiosk: (h, row) => (
            <a class="edit-wrapper" on-click={ () => this.edit(row) } id={row.id}>
              { this.$t('common.change') }
              <i class="icon icon--arrow" />
            </a>
          ),
          remove_kiosk: (h, row) => (
            <div class="delete-wrapper">
              <a on-click={ () => this.showConfirmation(row) } id={row.id}>
                <span class="delete-wrapper__icon icon icon--cross"></span>
              </a>
            </div>
          ),
        },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
@import '~styles/blocks/details.scss';
</style>



// WEBPACK FOOTER //
// src/components/tenants/KiosksTable.vue